import React from 'react';
import DateRangeContextType from './DateRangeContextType';

const DateRangeContext = React.createContext<DateRangeContextType | undefined>(
  undefined
);

export default DateRangeContext;
